module.exports = __webpack_public_path__ + "img/51000.42a48647.jpg";